import { render, staticRenderFns } from "./wechatBasicInfo.vue?vue&type=template&id=04d3cd03&scoped=true"
import script from "./wechatBasicInfo.vue?vue&type=script&lang=js"
export * from "./wechatBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./wechatBasicInfo.vue?vue&type=style&index=0&id=04d3cd03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3cd03",
  null
  
)

export default component.exports